<mat-card class="form-card">
  <mat-card-header class="custom-card-header market-dialog-header">
   <mat-card-title class="dialog-title-text">
  {{
    isEditMode
      ? ('Edit Market - ' + (marketForm.get('regionName')?.value || 'Unnamed'))
      : 'Add Market'
  }}
</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="marketForm" (ngSubmit)="onSubmit()" class="form-grid">
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Market</mat-label>
          <input
            matInput
            formControlName="regionName"
            required
            data-testId="regionName" maxlength="50"
          />
        </mat-form-field>
      </div>

      <div class="mat-mdc-dialog-actions">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="onCancel()"
          data-testId="btnCancel"
        >
          Cancel
        </button>
        @if(canSave){
          <button
            mat-raised-button
            color="primary"
            mat-primary
            type="submit"
            data-testId="btnSubmit"
          >
            {{ isEditMode ? "Update" : "Create" }}
          </button>
        }
      </div>
    </form>
  </mat-card-content>
</mat-card>
